import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '../LoadingIndicator.tsx';

// Added transform to create new stacking context
const Image = styled.img`
  opacity: 0;
  transition: 0.2s ease-in-out;
  width: 100%;
  height: auto;
  transform: translateZ(0);
`;

const LoadingIndicatorStyled = styled(LoadingIndicator)`
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--color-primary-05);
  border: 1px solid #ebebeb;
  border-radius: 2px;
  position: absolute;
`;

interface ProgressiveImageProps {
  isShowing?: boolean;
  className?: string;
  alt?: string;
  src?: string;
}

const ProgressiveImage = ({ isShowing = true, className, alt, src }: ProgressiveImageProps) => {
  const [hasLoadedBefore, setHasLoadedBefore] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState(src);

  if (src !== imageSrc) {
    setImageSrc(src);
    setHasLoaded(false);
  }

  useEffect(() => {
    if (hasLoaded && !hasLoadedBefore) {
      setHasLoadedBefore(true);
    }
  }, [hasLoaded, hasLoadedBefore]);

  return (
    <div className={className}>
      {!hasLoaded && <LoadingIndicatorStyled />}

      {(isShowing || hasLoadedBefore) && (
        <Image
          onLoad={() => setHasLoaded(true)}
          {...(hasLoaded && { style: { opacity: '1' } })}
          alt={alt}
          src={imageSrc}
        />
      )}
    </div>
  );
};

export default memo(ProgressiveImage);
